export const SHOW_APP_LOADER = 'SHOW_APP_LOADER';
export const HIDE_APP_LOADER = 'HIDE_APP_LOADER';
export const CURRENT_SELECTED_TAB = 'CURRENT_SELECTED_TAB';